import { render } from "./fundraisingRound.vue?vue&type=template&id=51ad5ccd&scoped=true"
import script from "./fundraisingRound.vue?vue&type=script&lang=ts"
export * from "./fundraisingRound.vue?vue&type=script&lang=ts"

import "./fundraisingRound.vue?vue&type=style&index=0&id=51ad5ccd&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-51ad5ccd"

export default script